import { ref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useGetEvents() {
    const events = ref({ data: [], meta: { current_page: 1 } });
    const loading = ref(true);

    async function getEvents(filters) {
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.events.index'),
                { filters }
            );
            events.value = res.data;
        } catch (error) {
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    return {
        events,
        loading,
        getEvents
    };
}
